import { fetchToken } from "../../../common/FetchCookie";
import { Unlocked_Candidate_LIST } from "../../../common/URLs";

export const UnlockedCandidateList = async (page = 1, per_page = 15) => {
    try {
        const token = await fetchToken();

        // console.log("Calling API with URL:", `${Unlocked_Candidate_LIST}?page=${page}&per_page=${per_page}`);

        const response = await fetch(`${Unlocked_Candidate_LIST}?page=${page}&per_page=${per_page}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        // console.log("API Response status:", response.status);

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("Error response:", errorData);
            throw new Error(`Failed with status ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("UnlockCandidate API error:", error);
        throw error;
    }
};